import { Linkedin, Facebook } from 'lucide-react';

const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Solutions', href: '#solutions' },
  { name: 'Products', href: '#products' },
  { name: 'Clients', href: '#clients' },
  { name: 'Careers', href: '#careers' },
  { name: 'Contact', href: '#contact' },
];

const socialLinks = [
  { icon: Linkedin, href: 'https://www.linkedin.com/company/hiresphereco', label: 'LinkedIn' },
  { icon: Facebook, href: 'https://www.facebook.com/hiresphereco', label: 'Facebook' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0D1321] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/59ffqy1d_hrsp_logo_text.png"
              alt="HireSphere"
              loading="lazy"
              decoding="async"
              className="h-10 w-auto mb-6"
            />
            <p className="text-white/60 leading-relaxed mb-6 max-w-md">
              HireSphere Sdn. Bhd. is a Malaysian IT solutions provider delivering AI-powered 
              platforms, custom software, and digital transformation for forward-looking organisations.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  data-testid={`social-${social.label.toLowerCase()}`}
                  aria-label={social.label}
                  className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-[#F5A623] hover:text-[#0D1321] transition-all"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <nav className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block py-2 text-white/60 hover:text-[#F5A623] transition-colors"
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <div className="space-y-3 text-white/60">
              <p>50-3, Jalan Metro Pudu</p>
              <p>Fraser Business Park</p>
              <p>Kuala Lumpur 55100</p>
              <p>Malaysia</p>
              <p className="pt-3">
                <a href="tel:+60143518576" className="inline-block py-1 hover:text-[#F5A623] transition-colors">
                  +6014-3518576
                </a>
              </p>
              <p>
                <a href="mailto:hello@hiresphere.co" className="inline-block py-1 hover:text-[#F5A623] transition-colors">
                  hello@hiresphere.co
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} HireSphere Sdn. Bhd. All rights reserved.
          </p>
          <p className="text-white/40 text-sm">
            Registration No: 202401014745 (1560595-H)
          </p>
        </div>
      </div>
    </footer>
  );
}
